var preciosAdmin = angular.module('preciosAdmin', []);

preciosAdmin.controller('preciosController', ['$scope', '$location', 'preciosAdminService', 'authenticationInfo', 'authenticationService', function ($scope, $location, preciosAdminService, authenticationInfo, authenticationService) {

    $scope.authentication = authenticationInfo;
    $scope.preciosSeleccionados = "";

    preciosAdminService.getPrecios()
            .then(function (response) {
                var data = response.data;
                $scope.precios = data;
            });

    $scope.verPrecios = function (idPrecio) {
        $location.path('/admin/editarPrecios/' + idPrecio);
    };

    $scope.crearPrecios = function () {
        $location.path('/admin/precios/nuevo');
    };
    
    $scope.preciosSeleccionados = ""
    $scope.eliminarPrecios = function () {
        var confirmado = confirm('¿Desea eliminar los precios seleccionados?')
        if (confirmado) {
            angular.forEach($scope.precios, function (precio) {
                if (precio.Selected) {
                    if ($scope.preciosSeleccionados != "") {
                        $scope.preciosSeleccionados = $scope.preciosSeleccionados + "," + precio.Id
                    } else {
                        $scope.preciosSeleccionados = precio.Id
                    }

                };
            });

            preciosAdminService.eliminarPrecios($scope.preciosSeleccionados).then(function (response) {
                var result = response.data;
                alert(result);
                $scope.preciosSeleccionados = [];
                preciosAdminService.getPrecios()
                    .then(function (response) {
                        var data = response.data;
                        $scope.precios = data;
                    });
            }).catch(function (response) {
                $scope.error = preciosAdminService.obtenerPrimerErrorModelState(response.data);
                alert($scope.error);
            });
        }
    };

        $scope.seleccionarTodos = function () {
            if (!$scope.SeleccionadosTodos) {
                $scope.SeleccionadosTodos = true;
            } else {
                $scope.SeleccionadosTodos = false;
            }
            angular.forEach($scope.precios, function (precio) {
                precio.Selected = $scope.SeleccionadosTodos;
            });

        };

    }]);